import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import { I18n } from "aws-amplify/utils";
const ConfirmDeleteStoreNote = ({ open, onClose, onConfirm }) => {
  return (
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>{I18n.get("Delete Confirmation")}</DialogTitle>
        <DialogContent>
          <DialogContentText>
          {I18n.get("Are you sure you want to delete this store note?")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            {I18n.get("Cancel")}
          </Button>
          <Button
            onClick={onConfirm} // Pass selected IDs when confirming
            color="primary"
            autoFocus
          >
            {I18n.get("Confirm")}
          </Button>
        </DialogActions>
      </Dialog>
    );
};

export default ConfirmDeleteStoreNote;
